import React from 'react';

const CheckboxIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.334 0.750183H5.665C2.644 0.750183 0.75 2.88918 0.75 5.91618V14.0842C0.75 17.1112 2.635 19.2502 5.665 19.2502H14.333C17.364 19.2502 19.25 17.1112 19.25 14.0842V5.91618C19.25 2.88918 17.364 0.750183 14.334 0.750183Z'
        fill='#6B7280'
      />
      <path
        d='M6.44141 10.0002L8.81541 12.3732L13.5614 7.6272'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CheckboxIcon;
